import { backendApi } from "@/services/api";
import type { Filter } from "@/shared/lib/filter/filter";

const statsApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    getStatsSummary: build.query<SummaryResponse, SummaryRequest>({
      query: (request) => ({
        url: `/inspections/stats/summary`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
    }),
    getCustomerStatistics: build.query<
      CustomerSummaryResponse,
      CustomerStatisticsRequest
    >({
      query: (request) => ({
        url: `/inspections/statistics/customer`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
    }),
    getCustomerTotals: build.query<
      CustomerTotalsResponse,
      CustomerTotalsRequest
    >({
      query: (request) => ({
        url: `/inspections/statistics/summary`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
    }),
  }),
});

export const {
  useGetStatsSummaryQuery,
  useGetCustomerStatisticsQuery,
  useGetCustomerTotalsQuery,
} = statsApi;

export interface SummaryRequest {
  from: string;
  to: string;
}

export interface CustomerSummary {
  customerId: string;
  surfaceMicrobialCount: number;
  airMicrobialCount: number;
  differentiationCount: number;
}

export interface SummaryResponse {
  items: CustomerSummary[];
}

export interface CustomerStatisticsRequest {
  customerId: string;
  from: Date;
  to: Date;
  limit: number;
  offset: number;
}

export interface CustomerInspectionSummary {
  inspectionId: string;
  processId: string;
  serviceObjectId: string;
  releaseDate: string;
  customerId: string;
  surfaceMicrobialCount: number;
  airMicrobialCount: number;
  differentiationCount: number;
}

export interface CustomerSummaryResponse {
  count: number;
  items: CustomerInspectionSummary[];
}

export interface CustomerTotalsRequest {
  customerId?: Filter<string>;
  from: Date;
  to: Date;
  limit: number;
  offset: number;
}

export interface CustomerTotals {
  customerId: string;
  surfaceMicrobialCount: number;
  airMicrobialCount: number;
  differentiationCount: number;
}

export interface CustomerTotalsResponse {
  count: number;
  items: CustomerTotals[];
}
